import React from "react";

import { Input, Text } from "components";

export const FormInput = ({ className, lines, label, value,readonly, hinttext,placeholder, errors=[],onChange=()=>{} }) => {
  return (
    <>
      <div className={className}>
        <Text
          className="text-black-900_dd text-s tracking-[0.50px] w-auto mb-2"
          size="txtInterRegular12Black900dd"
        >
          {label}
        </Text>
        <Input
          name="input"
          value={value}
          readonly={readonly}
          lines={lines}
          placeholder={placeholder??""}
          className="!placeholder:text-black-900_dd !text-black-900_dd font-inter md:h-auto p-0 sm:h-auto text-left text-sm tracking-[0.50px] w-full"
          wrapClassName="flex rounded-[5px] w-full"
          color={(Array.isArray(errors) && errors?.length>0)?"border_red_700":"indigo_A700_01"}
          onChange={onChange}
          size="sm"
          variant={(Array.isArray(errors) && errors?.length>0)?'error':'outline'}
          errors={errors}
        ></Input>
        {
          hinttext && <Text
            className="text-[14px] text-gray-700 font-thin w-auto"
            size="txtInterRegular11"
          >
            {hinttext}
          </Text>
        }
      </div>
    </>
  );
};

FormInput.defaultProps = {
  label: "Fullname",
  lines: 1
};

export default FormInput;
